var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg05(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 83.69 125.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14 62.87L10.28 0h69.33v20.48H30.42l-3.06 26.59A38.84 38.84 0 0146 42.4q17.67 0 27.7 11T83.69 84a44.87 44.87 0 01-5.06 21.45 35.72 35.72 0 01-14.48 14.7q-9.44 5.22-22.26 5.22a48 48 0 01-20.82-4.54A37 37 0 015.9 108.07 34.86 34.86 0 010 89.29h24.3q.76 7.74 5.39 12t12.11 4.29q8.33 0 12.83-6t4.5-17q0-10.55-5.18-16.15t-14.7-5.6q-8.74 0-14.19 4.58l-2.38 2.21z",
    fill: "#fff"
  })));
}
Svg05.displayName = '05';
export default Svg05;